import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { setUserSetting } from '../../state/actions/persist'
import {desktop } from '../../styles/media'
import Icon from '../../components/general/Icon'
import { events, trackEvent } from '../../helper/track'

const DarkModeToggle = ({ settings, setUserSetting }) => {
	const appearance = settings['app.appearance'] || 'light'

	const handleClick = () => {
		let newAppearance = appearance

		if (appearance === 'light') {
			newAppearance = 'system'
		} else if (appearance === 'system') {
			newAppearance = 'dark'
		} else if (appearance === 'dark') {
			newAppearance = 'light'
		}

		setUserSetting('app.appearance', newAppearance, true)

		trackEvent(events.SITE_CHANGE_APPEARANCE, {
			appearance: newAppearance
		})
	}

	return (
		<StyledDarkModeToggle onClick={handleClick}>
			{appearance === 'light' && <Icon name="sun" />}
			{appearance === 'system' && <Icon name="contrast" />}
			{appearance === 'dark' && <Icon name="moon" />}
		</StyledDarkModeToggle>
	)
}

DarkModeToggle.propTypes = {
	settings: PropTypes.object.isRequired,
	setUserSetting: PropTypes.func.isRequired
}

const StyledDarkModeToggle = styled.button`
	background: transparent;
	border: 0;
	color: ${props => props.theme.text};
	cursor: pointer;
	padding: 0;
	transition: 0.2s;

	height: 30px;
	width: 30px;

	align-items: center;
	display: flex;
	justify-content: center;

	${desktop`
		&:hover {
			opacity: 0.5;
		}
	`}
`

const enhance = connect(state => ({
	settings: state.persist.user.settings
}), dispatch => bindActionCreators({
	setUserSetting
}, dispatch))

export default enhance(DarkModeToggle)
